import React from 'react'
import {connect} from 'react-redux'
import Footer from '../../component/Footer'

/**
 * Main template containing the Top bar and the Footer that is common to all the content sections.
 */
const RawWrapper = ({Component, ...props}) => (
    <React.Fragment>
        <Component {...props}/>

        <Footer/>
    </React.Fragment>
)

const mapStateToProps = (state) => ({
    screen: state.forms.screen,
    formData: state.forms.formData
})

const DataBoundWrapper = connect(mapStateToProps)(RawWrapper)

const ToplessMain = Component => props => (
    <DataBoundWrapper {...props} Component={Component}/>
)

export default ToplessMain
